/**
 * Injects Clarity Script into the head.
 *
 * @param isEnabled Whether Clarity is enabled.
 * @param id The Clarity client ID.
 * @returns The Clarity script object.
 */
export function injectClarity({
  isEnabled,
  id,
}: {
  isEnabled: boolean
  id: string
}) {
  if (!isEnabled) {
    return
  }

  return {
    key: 'microsoft-clarity',
    type: 'text/javascript' as const,
    innerHTML: injectClarityScript({ id }),
  }
}

/**
 * Generates and returns the actual script content for Microsoft Clarity to be
 * injected.
 *
 * @param id The Clarity client ID.
 * @returns The Clarity script content.
 */
function injectClarityScript({
  id,
}: {
  id: string
}): string {
  return `
  (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${id}");
  `
}
